export default "__VITE_ASSET__BvvP7y9J__"